<template>
  <div id="app">
    <div uk-sticky
      class="uk-margin-bottom uk-navbar-container uk-sticky uk-sticky-fixed uk-active uk-sticky-below uk-padding-small"
      uk-navbar>
      <div class="uk-navbar-left">
        <img
          src="https://www.frankfordumbrellas.com/packages/frankford_theme/themes/frankford/images/frankford_logo_small.jpg"
          class="" alt="Frankford Logo">
        <span class="">Frankford Fabric Manager</span>
      </div>
      <div class="uk-navbar-right">
        <!-- <form class="uk-search uk-search-default" onsubmit="return false;">
          <span uk-search-icon></span>
          <input class="uk-search-input" onkeyup="filterSearch();" uk-filter-control="" type="search" placeholder="Search" aria-label="Search">
        </form> -->
      </div>
    </div>
    <router-view />
    <span class="add-fabric-container uk-position-bottom-right uk-padding">
      <router-link to="/new" class="uk-text-bold add-fabric uk-icon-button" uk-icon="icon: plus; ratio: 1.0;">
      </router-link>
    </span>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);

@Component
export default class App extends Vue { }
</script>

<style>
.add-fabric-container {
  position: fixed !important;
}

.uk-icon-button.add-fabric {
  transform: scale(1.5, 1.5);
  background: #333;
  color: #fff;
}

.uk-icon-button.add-fabric:hover {
  background: #666;
}
</style>
